import { Grid, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import * as React from "react";

import fileTypes from "../../data/fileType";

interface i_list {
  type: string;
  fileType: string;
}

const CollectionDisplay: React.FC<i_list> = ({
  type,
  fileType,
}): React.ReactElement => {
  return (
    <Grid
      container
      sx={{
        my: 0.5,
        ml: 1.5,
        borderBottom: "1px solid rgba(0,0,0,.1)",
        py: 0.5,
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: 1,
          justifyContent: "center",
        }}
      >
        <img src={fileTypes[`${fileType}`]} width="20" />
      </ListItemIcon>
      {type?.split("---")[0]?.length > 15 ? (
        <Tooltip title={type}>
          <ListItemText
            primary={type?.split("---")[0].substring(0, 13) + "..."}
            sx={{
              opacity: 1,
            }}
          />
        </Tooltip>
      ) : (
        <ListItemText
          primary={type?.split("---")[0]}
          sx={{
            opacity: 1,
          }}
        />
      )}
    </Grid>
  );
};

export default CollectionDisplay;
